import React from "react";
import moment from "moment";

function ViewOrder({ order, closeModal }) {
  return (
    <div className="modeldesignnew">
      <div className="overlaydesign"></div>
      <div className="modal fade show d-block" tabIndex={-1} aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content rounded-4 shadow-lg border-0">
            <div className="modal-header header_design text-white">
              <h5 className="modal-title"><i className="bi bi-receipt"></i> Order Details</h5>
              <button type="button" className="btn-close btncloseheading" onClick={closeModal} />
            </div>
            <div className="modal-body">

              {/* Order Summary */}
              <div className="card shadow-sm border-0 rounded-3 mb-1">
                <div className="card-header">
                  <h6 className=""><i className="bi bi-box"></i> Order Summary</h6>

                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6">
                      <h3>
                        <span>Order ID:</span>
                        <span className="detailspage"> {order?.bookingId}</span>
                      </h3>
                    </div>
                    <div className="col-md-6"><h3><span>Date:</span> <span className="detailspage"> {moment(order?.createdAt).format("DD MMM, YYYY hh:mm A")}</span></h3></div>
                    <div className="col-md-6"><h3><span>Booking Date:</span> <span className="detailspage"> {order?.bookingDate}</span></h3></div>
                    <div className="col-md-6"><h3><span>Time Slot:</span> <span className="detailspage"> {order?.bookingTime}</span></h3></div>
                    <div className="col-md-6">
                      <h3>
                        <span>Status:</span>
                        <span className="badge badgedesignsuccess">
                          {order?.status === "OutOfDelivery" ? "On The Way" : order?.status}
                        </span>
                      </h3>
                    </div>
                     <div className="col-md-6">
                      <h3>
                        <span>Invoice Number:</span>
                        <span className="badge badgedesignsuccess">
                          {order?.invoiceNumber}
                        </span>
                      </h3>
                    </div>
                    <div className="col-md-6"><h3><span>Payment Status:</span> <span className="badge badgedesignsuccess">{order?.paymentStatus}</span></h3></div>
                  </div>
                </div>
              </div>

              {/* Customer Details */}
              <div className="card shadow-sm border-0 rounded-3 mb-1">
                <div className="card-header">
                  <h6 className=""><i className="bi bi-person-circle"></i> Customer Details</h6>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6"><h3><span>Name:</span><span className="detailspage"> {order?.user?.firstName} {order?.user?.lastName}</span></h3></div>
                    <div className="col-md-6"><h3><span>Email:</span><span className="detailspage"> {order?.user?.email}</span></h3></div>
                    <div className="col-md-6"><h3><span>Phone:</span><span className="detailspage"> {order?.user?.mobileNo}</span></h3></div>
                    <div className="col-md-6"><h3><span>Address:</span><span className="detailspage"> {order?.address?.address}</span></h3></div>
                  </div>
                </div>
              </div>

              {/* Service Details */}
              <div className="card shadow-sm border-0 rounded-3 mb-1">
                <div className="card-header">
                  <h6 className=""><i className="bi bi-tools"></i> Service Details</h6>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6"><h3><span>Service Name:</span> <span className="detailspage"> {order?.service?.title}</span></h3></div>
                    <div className="col-md-6"><h3><span>Price:</span> <span className="detailspage"> ₹{order?.service?.price}</span></h3></div>
                    <div className="col-md-12"><h3><span>Description:</span> <span className="detailspage"> {order?.service?.description}</span></h3></div>
                  </div>
                </div>
              </div>

              {/* Add-ons */}
              {order?.addons?.length > 0 && (
                <div className="card shadow-sm border-0 rounded-3 mb-1">
                  <div className="card-header">
                    <h6 className=""><i className="bi bi-plus-circle"></i> Add-ons</h6>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      {order?.addons?.map((addon, index) => (
                        <div key={index} className="col-md-6"><h3><span>{addon?.title} </span>-  <span className="detailspage"> ₹{addon?.price}</span></h3></div>
                      ))}
                    </div>
                  </div>
                </div>
              )}


              {/* Coupon Details */}
              {order?.coupan && (
                <div className="card shadow-sm border-0 rounded-3 mb-1 bg-light">
                  <div className="card-header">
                    <h6 className=""><i className="bi bi-tags"></i> Coupon Applied</h6>
                  </div>
                  <div className="card-body">
                    <ul className="row">
                      <div className="col-md-6"><h3><span>Coupon Name:</span><span className="detailspage"> {order?.coupan?.name}</span></h3></div>
                      <div className="col-md-6"><h3><span>Discount:</span><span className="detailspage"> ₹{order?.coupan?.price} (Max ₹{order?.coupan?.maxDiscountAmount})</span></h3></div>
                      <div className="col-md-6"><h3><span>Validity:</span><span className="detailspage"> {new Date(order?.coupan?.endDate).toLocaleDateString()}</span></h3></div>
                      <div className="col-md-6"><h3><span>Status:</span><span className="badge badgedesignsuccess">{order?.coupan?.status}</span></h3></div>
                    </ul>
                  </div>
                </div>
              )}

              {/* Payment Details */}
              <div className="card shadow-sm border-0 rounded-3 mb-1">
                <div className="card-header">
                  <h6 className=""><i className="bi bi-credit-card"></i>Payment Details</h6>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6"><h3><span>Payment Method:</span> <span className="detailspage">{order?.paymentMethod}</span></h3></div>
                    <div className="col-md-6"><h3><span>Total Price:</span><span className="detailspage"> ₹{order?.totalPrice}</span></h3></div>
                    <div className="col-md-6"><h3><span>Pending Price:</span><span className="detailspage"> ₹{order?.pendingPrice}</span></h3></div>
                    <div className="col-md-6"><h3><span>Coupon Applied:</span><span className="detailspage"> -₹{order?.coupanPrice}</span></h3></div>
                    <div className="col-md-6"><h3><span>Final Amount:</span> <span className="fw-bold text-success">₹{order?.totalPrice}</span></h3></div>
                  </div>
                </div>
              </div>

              {/* Vendor Details */}
              {order?.vendor && (
                <div className="card shadow-sm border-0 rounded-3 mb-1">
                  <div className="card-header">
                    <h6 className=""><i className="bi bi-shop"></i> Vendor Details</h6>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6"><h3><span>Vendor Name:</span> <span className="detailspage">{order?.vendor?.name}</span></h3></div>
                      <div className="col-md-6"><h3><span>Vendor Mobile No:</span>  <span className="detailspage">{order?.vendor?.mobileNo}</span></h3></div>
                    </div>
                  </div>
                </div>
              )}

              {/* Action Buttons */}
              <div className="d-flex justify-content-end mt-4">
                <button className="btn btn-outline-danger px-4 py-2 me-2" onClick={closeModal}>
                  <i className="bi bi-x-circle"></i> Close
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewOrder;
